import { fetchPage, postPage } from "@/services/config";
import type { RawPaymentGatewaySettings, RawGatewayFetchResponse } from "@/types";

const serviceBase = "payments";

export interface GatewayUpdateResponse {
  is_configured: boolean;
}

export function getGatewaySettings(tenantId: number): Promise<RawGatewayFetchResponse> {
  return fetchPage<RawGatewayFetchResponse>(serviceBase, `/company/${tenantId}/gateway_settings`);
}

export function updateGatewaySettings(tenantId: number, payload: RawPaymentGatewaySettings): Promise<GatewayUpdateResponse> {
  return postPage<GatewayUpdateResponse, RawPaymentGatewaySettings>(
    serviceBase,
    `/company/${tenantId}/gateway_settings/update`,
    payload
  );
}
